import React from 'react';
import { ListContentListPage } from '../components/ListContentListPage';
import { FeatureArticleSmall } from '../components/feature/FeatureArticleSmall';
import type { ArticleRow } from '../../../shared/schemas/article';

function renderFeatures(articles: ArticleRow[]) {
  return (
    <div className="col-span-full grid grid-cols-1 gap-6 md:grid-cols-2">
      {articles.map((article) => (
        <FeatureArticleSmall key={article.slug} article={article} variant="featured" />
      ))}
    </div>
  );
}

export function FeaturesListPage() {
  return (
    <ListContentListPage
      title="Features"
      listProps={{
        emptyMessage: 'No feature articles yet.',
        fetchUrl: '/api/articles?type=feature',
        renderItems: renderFeatures,
      }}
    />
  );
}
